import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledTabSwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  & span {
    transition: color 0.3s;
  }
  & .tabs-content {
    position: relative;
    top: -2px;
  }
`;

export const StyledTabSwitchRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  height: fit-content;
  border-bottom: 1px solid ${theme.colors.purple_2};
`;

export const StyledTabSwitch = styled.div<{ $isActive: boolean }>`
  display: flex;
  flex-grow: 3;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 2px 16px 2px;
  gap: 10px;
  text-overflow: ellipsis;
  cursor: pointer;

  & .tab-counter {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: ${theme.variables.fs_10};
    background-color: ${(props) =>
      props.$isActive ? theme.colors.purple_2 : theme.colors.grey_5};
    height: fit-content;
    width: fit-content;
    padding: 0 6px;
    box-sizing: border-box;
    transition: background-color 0.3s;
    & span {
      transition: color 0.3s;
    }
  }
`;

export const StyledTabBookmark = styled.div<{
  $width: number;
  $left: number;
  $allowTransitions: boolean;
}>`
  position: relative;
  bottom: 2px;
  left: ${(props) => props.$left}px;
  width: ${(props) => props.$width}px;
  z-index: 2;
  display: flex;
  height: 2px;
  background-color: ${theme.colors.purple};
  border-radius: 10px 10px 0 0;
  transition: ${({ $allowTransitions }) =>
    $allowTransitions ? "all 300ms cubic-bezier(0.4, 0, 0.2, 1)" : "none"};
`;
